export enum ErrorsCodeEnum {
  INVALID_SEPA = 'INVALID_SEPA',
  VEHICLE_ALREADY_EXISTS = 'VEHICLE_ALREADY_EXISTS',

  //Cancel transport order
  ERROR_CANCEL_TRANSPORT_ORDER_CB = 'ERROR_CANCEL_TRANSPORT_ORDER_CB',
  ERROR_CANCEL_TRANSPORT_ORDER_BILL = 'ERROR_CANCEL_TRANSPORT_ORDER_BILL',
  ERROR_CANCEL_TRANSPORT_ORDER_EDI = 'ERROR_CANCEL_TRANSPORT_ORDER_EDI',

  ERROR_LOGIN_ALREADY_EXIST = 'userexists',
  ERROR_EMAIL_ALREADY_EXIST = 'emailexists',
}
